import { reviews } from './global'

export const initLandingPage = () => {
    initProductSwipers()
    faqAccordion()
    ratingsSwiper()
    fixedCtaBar()
}

function fixedCtaBar() {
    const trigger = document.querySelector('#custom-products-cta-trigger')
    const ctaBar = document.querySelector('.fixed-cta-bar')

    if (!trigger || !ctaBar) return

    const checkScroll = () => {
        const triggerBottom = trigger.getBoundingClientRect().bottom + window.scrollY
        const currentScroll = window.scrollY

        if (currentScroll > triggerBottom) {
            ctaBar.classList.add('active')
        } else {
            ctaBar.classList.remove('active')
        }
    }

    // Check on load
    checkScroll()

    // Check on scroll
    window.addEventListener('scroll', checkScroll)
}

function ratingsSwiper() {
    const swiperContainer = document.querySelector('.lp-ratings .swiper-ratings')
    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper')

    $('.placeholder').remove()

    reviews.forEach((review) => {
        const slide = document.createElement('div')
        slide.className = 'swiper-slide'

        slide.innerHTML = `
            <div class="reviews-upper">
                <img class="reviews-avatar" src="${review.image}" alt="${
            review.name
        }" style="width: 56px; border-radius: 50%;">
                <div>
                    <h3 class="reviews-header" style="margin: 0 auto;">${review.name}</h3>
                    <p class="reviews-work" style="font-size: 13px; opacity: 0.7;">${review.position}</p>
                    <div class="stars">
                        ${Array(5)
                            .fill()
                            .map(
                                () => `
                            <svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#F57C00">
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                            </svg>
                        `
                            )
                            .join('')}
                    </div>
                </div>
            </div>
            <p class="review-text">${review.text}</p>
        `

        swiperWrapper.appendChild(slide)
    })

    // Initialize Swiper
    new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2.3,
            },
            1199: {
                slidesPerView: 3.5,
            },
        },
    })
}

function initProductSwipers() {
    const customProductsBlocks = document.querySelectorAll('.custom-products-block')

    if (customProductsBlocks.length) {
        let swipers = []

        const initSwipers = () => {
            if (window.innerWidth < 768) {
                customProductsBlocks.forEach((block, index) => {
                    if (!swipers[index]) {
                        swipers[index] = new Swiper(block, {
                            spaceBetween: 24,
                            pagination: false,
                            navigation: false,
                            breakpoints: {
                                520: {
                                    slidesPerView: 2.3,
                                    spaceBetween: 24,
                                },

                                0: {
                                    slidesPerView: 1.3,
                                    spaceBetween: 24,
                                },
                            },
                        })
                    }
                })
            } else {
                swipers.forEach((swiper, index) => {
                    if (swiper) {
                        swiper.destroy(true, true)
                        swipers[index] = null
                    }
                })
            }
        }

        initSwipers()

        window.addEventListener('resize', () => {
            initSwipers()
        })
    }
}

function faqAccordion() {
    const accordions = document.querySelectorAll('.accordion details')

    accordions.forEach((accordion) => {
        const content = accordion.querySelector('.accordion__content')
        const summary = accordion.querySelector('summary')

        content.style.maxHeight = '0px'
        content.style.opacity = '0'
        content.style.transition = 'max-height 0.3s ease-out, opacity 0.3s ease-out'
        content.style.overflow = 'hidden'

        summary.addEventListener('click', (e) => {
            e.preventDefault()

            accordions.forEach((otherAccordion) => {
                if (otherAccordion !== accordion) {
                    const otherContent = otherAccordion.querySelector('.accordion__content')
                    otherContent.style.maxHeight = '0px'
                    otherContent.style.opacity = '0'
                    otherAccordion.removeAttribute('open')
                }
            })

            if (accordion.hasAttribute('open')) {
                content.style.maxHeight = '0px'
                content.style.opacity = '0'
                setTimeout(() => {
                    accordion.removeAttribute('open')
                }, 300)
            } else {
                accordion.setAttribute('open', '')
                content.style.maxHeight = content.scrollHeight + 'px'
                content.style.opacity = '1'
            }
        })
    })
}
